const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/home', // Redirect to the root path
    omitFromNav: true,
  },
];

export default routes;
